import type { FacilityEquipment } from '@reliance/types/models/FacilityEquipment';
import { useAsync, type UseAsyncReturn } from 'react-async-hook';
import api from '../common/api';
import type { IPaginatedResponse } from '../common/reliance-api-service';

/**
 * Loads facility equipment for a facility (`GET /facility-equipment?facilityId=`).
 * Call `execute(facilityId)` to refresh.
 */
export function useFacilityEquipmentList(
  facilityId: number | undefined
): UseAsyncReturn<FacilityEquipment[], [number | undefined]> {
  return useAsync(
    async (): Promise<FacilityEquipment[]> => {
      if (facilityId == null) {
        return [];
      }
      const res = await api.get<IPaginatedResponse<FacilityEquipment>>('/facility-equipment', {
        params: { facilityId, page: 1, perPage: 1000 },
      });
      return res.data?.data ?? [];
    },
    [facilityId]
  );
}
